module.exports = __webpack_public_path__ + "img/resalat.59e8bc15.png";